export * from './search.component';



// WEBPACK FOOTER //
// ./src/app/components/search/index.ts